import { render, staticRenderFns } from "./BookingModule.vue?vue&type=template&id=57b89c76"
import script from "./BookingModule.vue?vue&type=script&lang=js"
export * from "./BookingModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports